import { agentHubOrSubBrandConfig } from 'agentHub/constants'

/**
 * Leaf flag for Agent Hub enablement.
 * Kept out of agentHubSelectors so checkout/flight selectors can use it without
 * pulling commissionMap (and the getAllItemViewsByType cycle) via agentHubSelectors.
 */
export const isAgentHubEnabled = agentHubOrSubBrandConfig.isEnabled
